import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { DeleteDepartmentResponse } from 'src/types/department';
import axiosInstance from 'src/utils/axios';

export interface DeleteDepartmentRequest {
  departmentIds: number[];
}

interface UseDeleteDepartmentMutationOptions {
  companyId: string;
  onSuccess?: (data: DeleteDepartmentResponse) => void;
  onError?: (error: any) => void;
}

const useDeleteDepartmentMutation = ({
  companyId,
  onSuccess,
  onError,
}: UseDeleteDepartmentMutationOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: DeleteDepartmentRequest) => {
      const res = await axiosInstance.post<DeleteDepartmentResponse>(
        api.deleteDepartment(companyId),
        params.departmentIds
      );
      return res.data;
    },
    onSuccess: (data) => {
      // Invalidate department list queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.department.departmentList(companyId.toString())],
      });
      // Invalidate clients query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.company.clients(companyId.toString())],
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useDeleteDepartmentMutation;
